export default "__VITE_ASSET__0d6bd129__"